import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className='w-full h-full flex flex-col gap-6 p-6 md:p-10 text-gray-800 leading-relaxed'>
      <h1 className='text-2xl md:text-3xl font-semibold underline text-center'>
        Privacy Policy
      </h1>

      <p>
        Mukunda Silver Jewellers (“we”, “our”, “us”) is committed to protecting
        your privacy. This Privacy Policy explains how we collect, use, store,
        and protect your personal information when you visit our website or make
        a purchase.
      </p>
      <p>
        By using our website, you agree to the practices described in this
        policy.{' '}
      </p>

      <div className='flex flex-col gap-8'>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>1. Information We Collect</h2>
          <p className='ml-6 mb-3'>
            We collect the following types of information:{' '}
          </p>
          <h2 className='font-bold text-lg mb-3'>1.1 Personal Information </h2>
          <p className='ml-6 mb-3'>
            When you make a purchase, create an account, or contact us, we may
            collect:
          </p>
          <ul className='ml-10 list-disc flex flex-col gap-2'>
            <li>Name</li>
            <li>Phone number</li>
            <li>Email address</li>
            <li>Billing and shipping address</li>
            <li>
              Payment-related details (processed securely via payment gateway){' '}
            </li>
          </ul>
          <h2 className='font-bold text-lg mb-3 mt-3'>
            1.2 Non-Personal Information{' '}
          </h2>

          <ul className='ml-10 list-disc flex flex-col gap-2'>
            <li>IP address</li> <li>Browser type and device information </li>
            <li>Pages visited and usage patterns on our website </li>
            <li>Cookies and tracking technologies</li>
          </ul>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            2. How We Use Your Information{' '}
          </h2>
          <p className='ml-6 mb-3'>
            {' '}
            We use your information for the following purposes:{' '}
          </p>

          <ol className='ml-10 list-decimal flex flex-col gap-2'>
            <li>
              <strong>Order Processing –</strong> To confirm, process, and
              deliver your orders.
            </li>
            <li>
              <strong>Customer Support –</strong> To respond to your queries and
              provide assistance.{' '}
            </li>
            <li>
              <strong>Personalization – </strong>To improve your shopping
              experience.{' '}
            </li>
            <li>
              <strong>Marketing & Updates –</strong> To send promotional offers,
              updates, and notifications (only if you opt-in).{' '}
            </li>
            <li>
              <strong>Security – </strong>To detect and prevent fraud or misuse.{' '}
            </li>
            <li>
              <strong>Website Improvement –</strong> To analyse website
              performance and user behaviour.{' '}
            </li>
          </ol>
        </div>
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            {' '}
            3. How We Share Your Information
          </h2>
          <p className='ml-6 mb-3'>
            We do not sell or rent your personal information.{' '}
          </p>
          <p className='ml-6 mb-3'>We may share your information only with:</p>
          <ol className='ml-10 list-decimal flex flex-col gap-2'>
            <li>
              <strong>Courier/Logistics partners –</strong> To deliver your
              orders.
            </li>
            <li>
              <strong>Payment gateway providers –</strong> To process your
              payments securely.
            </li>
            <li>
              <strong>Service providers –</strong> IT support, analytics,
              marketing (if applicable).
            </li>
            <li>
              <strong>Legal authorities – </strong>Only if required by law, to
              protect our rights or prevent fraud.
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'>
            {' '}
            4. Cookies & Tracking Technologies
          </h2>
          <p className='ml-6 mb-3'>We use cookies to: </p>

          <ol className='ml-10 list-disc flex flex-col gap-2'>
            <li>Remember your preferences</li>
            <li>Improve website functionality</li>
            <li>Analyse website performance </li>
          </ol>
          <p className='mt-3'>
            You can disable cookies in your browser settings, but some features
            may not work correctly.
          </p>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 5. Data Security</h2>
          <p className='ml-6 mb-3'>
            We follow standard security practices to protect your data,
            including:{' '}
          </p>
          <ol className='ml-10 list-decimal flex flex-col gap-2'>
            <li>Encrypted connections (SSL)</li>
            <li>Secure payment gateways</li>
            <li>Access-controlled systems</li>
          </ol>
          <p className='ml-6 mb-3'>
            However, no data transmission over the internet is 100% secure. We
            take all reasonable steps to safeguard your information.{' '}
          </p>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 6. Your Rights</h2>
          <p className='ml-6 mb-3'>You have the right to: </p>
          <ol className='ml-10 list-decimal flex flex-col gap-2'>
            <li>Access the personal data we hold about you</li>
            <li>Request corrections to your information</li>
            <li>Opt-out of marketing communications</li>
            <li>
              Request deletion of your data (subject to legal requirements)
            </li>
          </ol>
          <p className='ml-6 mb-3 mt-3'>To exercise these rights, contact us at:</p>
          <p className='font-bold text-lg ml-6 mb-3'>[Add Email / Phone Number] </p>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 7. Third-Party Links</h2>

          <ol className='ml-6 flex flex-col gap-2'>
            <li>
              Our website may contain links to third-party websites. We are not
              responsible for their privacy practices or content. Please review
              their policies before sharing information.
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 8. Children’s Privacy</h2>

          <ol className='ml-6 flex flex-col gap-2'>
            <li>
              We do not knowingly collect information from individuals under the
              age of 18. If you believe a minor has provided information, please
              contact us to remove it.
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 9. Policy Updates</h2>

          <ol className='ml-6 flex flex-col gap-2'>
            <li>
              We may update this Privacy Policy from time to time. All updates
              will be posted on this page with the revised date.
            </li>
          </ol>
        </div>{' '}
        <div className='p-5 border rounded-xl shadow-sm'>
          <h2 className='font-bold text-lg mb-3'> 10. Contact Us</h2>

          <ol className='ml-6 flex flex-col gap-2'>
            <li>
              If you have any questions or concerns about this Privacy Policy,
              please contact us:
            </li>
          </ol>
        </div>{' '}
      </div>
    </div>
  );
};

export default PrivacyPolicy;
